import { map, mergeRight, propOr } from 'ramda';
import { calculateHealthInsurancesWithFranchise } from './applyFranchiseToIntervals.js';
import { calculateDailyBaseAmount, calculateDailyRevenue, getFranchiseForTab } from './intervalsHelpers.js';
import { getReimbursementGraphContent } from './getReimbursementGraphContent.js';

const parseToFloat = value => parseFloat(value) || 0;

export const buildTabsWithHealthInsurances = ({
  tabs,
  franchiseMap,
  buildIntervalsFunc,
  buildIntervalsParams,
  annualIncome,
  PASS,
  capValue
}) => {
  const dailyRevenue = calculateDailyRevenue(annualIncome);

  const enrichTab = tab => {
    const tabFranchise = getFranchiseForTab(tab, franchiseMap);

    const tabIntervalsData = buildIntervalsFunc({
      ...buildIntervalsParams,
      franchise: tabFranchise
    });

    const percentage = parseToFloat(capValue);
    const isAboveOnePASS = annualIncome > PASS;
    const baseAmount = calculateDailyBaseAmount(annualIncome, percentage);

    const tabHealthInsurances = calculateHealthInsurancesWithFranchise(
      propOr([], 'intervals', tabIntervalsData),
      propOr([], 'ROs', tabIntervalsData),
      baseAmount,
      isAboveOnePASS,
      tabFranchise
    );

    const tabGraphContent = getReimbursementGraphContent(
      tabHealthInsurances,
      propOr([], 'labels', tabIntervalsData),
      propOr([], 'ROs', tabIntervalsData)
    );

    return mergeRight(tab, {
      labels: tabIntervalsData.labels,
      ROs: tabIntervalsData.ROs,
      intervals: tabIntervalsData.intervals,
      healthInsurances: map(parseToFloat, tabHealthInsurances),
      rows: tabGraphContent.rows,
      note: tabGraphContent.note,
      dailyRevenue
    });
  };

  return map(enrichTab, tabs);
};
